var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowResulsCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0626 19.0595C12.4768 19.6453 11.5256 19.6453 10.9398 19.0595L1.94285 10.0612C1.3571 9.47541 1.3571 8.52403 1.94285 7.93821C2.52859 7.35238 3.47983 7.35238 4.06557 7.93821L12.0035 15.8773L19.9415 7.94289C20.5272 7.35707 21.4785 7.35707 22.0642 7.94289C22.65 8.52872 22.65 9.48009 22.0642 10.0659L13.0672 19.0642L13.0626 19.0595Z",
    fill: "#1C191A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowResulsCard);
export default __webpack_public_path__ + "static/media/ArrowResulsCard.2bce2113c92527a595d2dd45fe0db29a.svg";
export { ForwardRef as ReactComponent };